import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  {
    number: "01",
    title: "Omni-channel Ingestion",
    description: "Email-based ticket ingestion and secure web portal submission. Additional integrations are currently in development."
  },
  {
    number: "02",
    title: "AI Detection",
    description: "The AI Core instantly identifies intent, sentiment, and technical category with granular context awareness."
  },
  {
    number: "03",
    title: "Root Cause Analysis",
    description: "Our semantic reasoning engine scans knowledge bases and system logs to diagnose the exact underlying issue."
  },
  {
    number: "04",
    title: "Autonomous Resolution",
    description: "Standard L1/L2 issues are resolved via automated workflows. Complex cases are intelligently escalated."
  },
  {
    number: "05",
    title: "Continuous Learning",
    description: "The system learns from every resolution, updating its knowledge graph to handle similar future tickets faster."
  }
];

const metrics = [
  { value: "60%", label: "Faster MTTR" },
  { value: "95%", label: "Auto Classification" },
  { value: "40%", label: "L1 Cost Reduction" },
  { value: "24/7", label: "AI Availability" }
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="how-section section-padding bg-gradient">
      <div className="container">
        <div className="section-header">
          <h2 className="title">Intelligent Workflow, Autonomous Results</h2>
          <p className="subtitle">Raptic91<sup>™</sup> maps directly to your existing ITIL processes, replacing manual labor with AI speed.</p>
        </div>

        <div className="steps-container">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="step-item"
              initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="metrics-grid">
          {metrics.map((metric, index) => (
            <div key={index} className="metric-card">
              <div className="metric-value">{metric.value}</div>
              <div className="metric-label">{metric.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
